var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('avatar',{attrs:{"color":"accent","medium":!_vm.small,"small":_vm.small}},[_c('v-icon',{staticClass:"system-icon material-icons-outlined",attrs:{"color":"white","small":"","x-small":_vm.small}},[_vm._v(" cloud ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }